query TimeZones(  $countryId: Int)
{
 timeZones(orderBy:  [DESCRIPTION_ASC, ACTIVE_TIME_ZONE_CODE_ASC]
       filter: { countryId: { equalTo: $countryId } }
){
  nodes{
    id
    __typename
   description
   activeTimeZoneCode
  }
}
}